import React from "react";
import { ToggleGroup, ToggleGroupItem } from "./toggle-group";

// A joined row of mutually-exclusive options.
//
// Every segment keeps all four borders. Dropping the inner one (border-r-0 /
// border-l-0) collapses the doubled seam but also strips that edge from the
// SELECTED chip, leaving its highlight box open on one side. Instead the seam is
// collapsed with a negative margin, and the selected item is raised so its
// border wins over both neighbours.
const BASE_ITEM =
  "relative text-xs h-9 border border-border/50 bg-background/40 " +
  "data-[state=on]:bg-primary/20 data-[state=on]:text-primary " +
  "data-[state=on]:border-primary/50 data-[state=on]:z-10";

const positionClass = (index, count) => {
  if (count === 1) return "";
  if (index === 0) return "rounded-r-none";
  if (index === count - 1) return "rounded-l-none -ml-px";
  return "rounded-none -ml-px";
};

/**
 * @param options  [{ value, label }] — rendered left to right.
 * @param onChange called with the new value; a deselection (Radix clears the
 *                 value when the active item is tapped again) is ignored, so the
 *                 control is never left without a selection.
 */
const SegmentedToggle = ({
  id,
  value,
  onChange,
  options,
  className = "",
  itemClassName = "",
}) => (
  <ToggleGroup
    id={id}
    type="single"
    value={value}
    onValueChange={(next) => {
      if (next) onChange(next);
    }}
    className={`gap-0 flex ${className}`}
  >
    {options.map((option, index) => (
      <ToggleGroupItem
        key={option.value}
        value={option.value}
        className={`${BASE_ITEM} ${positionClass(index, options.length)} ${itemClassName}`}
      >
        {option.label}
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
);

export default SegmentedToggle;
